"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--sds--ursa-icons--background-color, transparent)",
  d: "M6.445 5.269h4.397a3 3 0 0 1 3 2.999V13.5a4 4 0 0 1-4 4H6.445a3 3 0 0 1-3-3V8.269a3 3 0 0 1 3-3"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.555 3.9H9.158a1.6 1.6 0 0 0-1.6 1.6h-1.4a3 3 0 0 1 3-3h4.397a3 3 0 0 1 3 3v6.231a3 3 0 0 1-3 3v-1.4a1.6 1.6 0 0 0 1.6-1.6V5.5a1.6 1.6 0 0 0-1.6-1.6"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.26 17.478a4 4 0 0 1-.418.022H6.445a3 3 0 0 1-3-3V8.269a3 3 0 0 1 3-3h4.397a3 3 0 0 1 3 2.999V13.5q0 .212-.022.419a4 4 0 0 1-3.56 3.56m2.182-4.959V8.268a1.6 1.6 0 0 0-1.6-1.6H6.445a1.6 1.6 0 0 0-1.6 1.6V14.5a1.6 1.6 0 0 0 1.6 1.6H8.86v-1.381a2.2 2.2 0 0 1 2.2-2.2zm-2.181 3.547V14.72a.8.8 0 0 1 .8-.8h1.347a2.6 2.6 0 0 1-2.147 2.147",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=FilesIcon20.js.map